import { inject, Service } from '@angular/core';
import { ServicesService } from '../services';

@Service()
export class FeedbackEndpointsService {
  readonly #servicesService = inject(ServicesService);

  postEndpoint() {
    return this.#servicesService.thorEndpoint(`feedback`);
  }

  getEndpointTeacher(
    actor: string,
    arrangementCode: string,
    contentPath: string,
  ) {
    const contentIdentifier = contentPath.split('/').pop();

    return this.#servicesService.thorEndpoint(
      `feedback/actor/${actor}/arrangement/${arrangementCode}/content/${contentIdentifier}`,
    );
  }

  getEndpointStudent(arrangementCode: string, contentPath: string) {
    const contentIdentifier = contentPath.split('/').pop();

    return this.#servicesService.thorEndpoint(
      `feedback/arrangement/${arrangementCode}/content/${contentIdentifier}`,
    );
  }
}
